module.exports = __webpack_public_path__ + "static/img/img_logo_9.8340150c.png";